import React from 'react';
import './Header.css';

const Header = () => {
  return (
    <div className="header">
      {/* Header minimalista - solo para separación visual */}
    </div>
  );
};

export default Header;
